import Vue from 'vue'
import get from 'lodash/get'

import { completion } from '@/lib/firestore'
import { auth } from '@/services/firebase'

import * as Types from './types'

export default {
  [Types.REGISTER_COMPLETION]: async (context, { contentType, id, status }) => {
    context.commit(Types.SET_COMPLETION, { contentType, id, status })

    completion.set(get(auth, ['currentUser', 'uid'], null), context.state)
  },
  [Types.HYDRATE_COMPLETION]: ({ rootState }, { completionState }) => {
    Vue.set(rootState, 'completion', completionState)
  }
}
